/**
 * Custom Upload Component
 * Extends Ant Design Upload with custom styling
 */

import { Upload as AntUpload, UploadProps } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import './CustomUpload.scss';
import { CustomButton } from '../CustomButton';

export interface CustomUploadProps extends UploadProps {
  /** Upload variant */
  variant?: 'default' | 'dragger' | 'avatar';
}

/**
 * CustomUpload Component
 */
export const CustomUpload: React.FC<CustomUploadProps> = ({
  variant = 'default',
  className,
  children,
  ...rest
}) => {
  const uploadClasses = classNames('custom-upload', `custom-upload--${variant}`, className);

  if (variant === 'dragger') {
    return (
      <AntUpload.Dragger {...rest} className={uploadClasses}>
        {children || (
          <div className="custom-upload__dragger-content">
            <UploadOutlined style={{ fontSize: 48, color: 'var(--color-primary, #2563eb)' }} />
            <p>Click or drag file to this area to upload</p>
          </div>
        )}
      </AntUpload.Dragger>
    );
  }

  return (
    <AntUpload {...rest} className={uploadClasses}>
      {children || (
        <CustomButton icon={<UploadOutlined />} variant="ghost">
          Upload
        </CustomButton>
      )}
    </AntUpload>
  );
};

export default CustomUpload;

